import { useMemo } from 'react';
import { isNil, omitBy } from 'lodash';

import { EMPTY_STRING } from '@e-socna/empty';

import { useIdFactory } from '../../../hooks/useIdFactory.hook';
import type { TextualContent } from '../../../components/DocumentEditor/types/textual-content.type';

export const useInitialValuesFactory = (pInitialValues?: TextualContent) => {
  const { generateId } = useIdFactory();

  const initialValues: TextualContent = useMemo(
    () => ({
      _id: generateId(),
      ...omitBy(pInitialValues, isNil),
      title: pInitialValues?.title ?? EMPTY_STRING,
      content: pInitialValues?.content ?? EMPTY_STRING,
    }),
    [pInitialValues, generateId],
  );

  return { initialValues };
};
